"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("../../scss/application.scss");
const connected_react_router_1 = require("connected-react-router");
const react_error_boundary_1 = require("react-error-boundary");
const react_redux_1 = require("react-redux");
require("react-toastify/dist/ReactToastify.css");
const components_1 = require("components");
const hooks_1 = require("hooks");
const store_1 = __importDefault(require("store"));
const browserHistory_1 = __importDefault(require("../services/browserHistory"));
const Routes_1 = __importDefault(require("./Routes"));
function App() {
    (0, hooks_1.useErrorListener)();
    return ((0, jsx_runtime_1.jsx)(react_error_boundary_1.ErrorBoundary, { fallbackRender: ({ error }) => (0, jsx_runtime_1.jsx)(components_1.FallbackErrorScreen, { error: error }), children: (0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: store_1.default, children: (0, jsx_runtime_1.jsx)(connected_react_router_1.ConnectedRouter, { history: browserHistory_1.default, children: (0, jsx_runtime_1.jsx)(Routes_1.default, {}) }) }) }));
}
exports.default = App;
